import React from 'react';
import '../product/ProductV2.css'; // shared pv2-subnav chrome (matches Products)

// Services sub-navigation: the management list vs the new Data tab. Reuses the
// same pv2-subnav look as Products so the Catalogue reads consistently.
const TABS = [
  { id: 'services', label: 'Services' },
  // 'Data' (service analytics) hidden for launch — it exposes revenue figures
  // and needs role-based access before anyone but the owner should see it.
  // Restore { id: 'data', label: 'Data' } when roles land.
];

// With Data hidden there is only one tab, and a lone tab is just a line
// under the title; show the bar again once there are two.
const ServiceSubNav = ({ active, onChange, counts = {} }) => TABS.length < 2 ? null : (
  <div className="pv2-subnav" role="tablist">
    {TABS.map((tab) => {
      const count = counts[tab.id];
      const isActive = active === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`pv2-subnav-tab ${isActive ? 'active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          {count != null && <span className="pv2-subnav-count">{count}</span>}
        </button>
      );
    })}
  </div>
);

export default ServiceSubNav;
